import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a852dc8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-container"
};
const _hoisted_2 = {
  class: "swiper-container"
};
const _hoisted_3 = {
  class: "swiper-wrapper"
};
const _hoisted_4 = {
  class: "swiper-slide"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  muted: "",
  autoplay: "",
  loop: "",
  src: "/video/p2-发电厂区.mp4"
}, [/*#__PURE__*/_createElementVNode("source", {
  src: "/video/p2-发电厂区.mp4",
  type: "video/mp4"
})], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "dis-space-4 me-max-title main-title-shadow"
}, "大宗商品数字供应链服务商", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "info dis-space-2 me-main-title"
}, "让大宗商品流通 像快递一样简单", -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = {
  class: "swiper-slide"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "平台大数据", -1));
const _hoisted_11 = {
  class: "static"
};
const _hoisted_12 = {
  class: "static-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, " 万+", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "static-item-type me-content-lg"
}, "注册司机", -1));
const _hoisted_15 = {
  class: "static-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, " 万+", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "static-item-type me-content-lg"
}, " 整合运力", -1));
const _hoisted_18 = {
  class: "static-item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, " +", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "static-item-type me-content-lg"
}, "货主企业", -1));
const _hoisted_21 = {
  class: "static-item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, " 万+", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "static-item-type me-content-lg"
}, "运单数量", -1));
const _hoisted_24 = {
  class: "static-item"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "unit"
}, " 亿吨+", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "static-item-type me-content-lg"
}, "货运总量", -1));
const _hoisted_27 = {
  class: "data-img-panel"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "swiper-slide"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "解决方案", -1));
const _hoisted_31 = {
  class: "project-content"
};
const _hoisted_32 = {
  class: "left"
};
const _hoisted_33 = ["onClick", "onMouseenter"];
const _hoisted_34 = {
  class: "sq dis-space-2"
};
const _hoisted_35 = {
  class: "item-info"
};
const _hoisted_36 = {
  class: "dis-space-1 me-sub-title"
};
const _hoisted_37 = {
  class: "me-content"
};
const _hoisted_38 = {
  class: "right"
};
const _hoisted_39 = {
  class: "title"
};
const _hoisted_40 = {
  class: "dis-space-1"
};
const _hoisted_41 = {
  class: "dis-space-1 me-sub-title"
};
const _hoisted_42 = {
  class: "text-content dis-space-1 me-content"
};
const _hoisted_43 = {
  class: "project-img-panel"
};
const _hoisted_44 = ["src"];
const _hoisted_45 = {
  class: "swiper-slide"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-2"
}, " 关于安徽达链", -1));
const _hoisted_47 = {
  class: "about-content"
};
const _hoisted_48 = {
  class: "left"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title me-sub-title dis-space-1"
}, "基于物联网、云计算、人工智能等新一代信息技术", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dis me-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "以大数据分析为核心建立决策系统，"), /*#__PURE__*/_createElementVNode("span", null, "以业务场景实践推进数字化供应链转型。"), /*#__PURE__*/_createElementVNode("span", null, " 持续打造大宗领域更具领先性和普惠价值的数智创新平台，"), /*#__PURE__*/_createElementVNode("span", null, "形成技术驱动、平台赋能的物流业制造业融合发展新生态。")], -1));
const _hoisted_51 = {
  class: "right"
};
const _hoisted_52 = ["src"];
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "r1"
}, [/*#__PURE__*/_createElementVNode("label", {
  class: "figure-freight-img"
}), /*#__PURE__*/_createElementVNode("label", {
  class: "figure-finance-img"
})], -1));
const _hoisted_54 = {
  class: "r2"
};
const _hoisted_55 = {
  class: "platfrom-img"
};
const _hoisted_56 = ["src"];
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "r3"
}, [/*#__PURE__*/_createElementVNode("label", {
  class: "figure-link-img"
}), /*#__PURE__*/_createElementVNode("label", {
  class: "figure-enertgy-img"
})], -1));
const _hoisted_58 = {
  class: "swiper-slide"
};
const _hoisted_59 = {
  class: "content"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-2 me-main-title"
}, " 合作客户", -1));
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title dis-space-1 me-content"
}, "以用户至上、合作共赢的价值观，持续提供优质服务", -1));
const _hoisted_62 = {
  class: "grid-compnay"
};
const _hoisted_63 = {
  class: "team-grid-content"
};
const _hoisted_64 = ["src"];
const _hoisted_65 = {
  class: "swiper-slide"
};
const _hoisted_66 = {
  class: "layout-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_count_to = _resolveComponent("count-to");
  const _component_Cooperation = _resolveComponent("Cooperation");
  const _component_b_footer = _resolveComponent("b-footer");
  const _component_ConsultModal = _resolveComponent("ConsultModal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    id: "home-container",
    class: "certify-content",
    style: _normalizeStyle({
      height: _ctx.height
    })
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "home-banner",
    style: _normalizeStyle({
      height: _ctx.height
    }),
    id: "home-banner"
  }, [_hoisted_5, _createElementVNode("div", {
    class: "banner-info",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, _hoisted_8, 4)], 4)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["date-static default-animation-wrap", {
      entry: _ctx.activeSliderIndex === 1
    }]),
    style: _normalizeStyle({
      height: _ctx.height
    }),
    id: "date-static"
  }, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("label", null, [_ctx.activeSliderIndex === 1 ? (_openBlock(), _createBlock(_component_count_to, {
    key: 0,
    class: "count-to-label",
    autoplay: true,
    startVal: 1,
    "end-val": 101.2,
    decimals: 2,
    duration: 3000
  }, null, 8, ["end-val"])) : _createCommentVNode("", true), _hoisted_13]), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createElementVNode("label", null, [_ctx.activeSliderIndex === 1 ? (_openBlock(), _createBlock(_component_count_to, {
    key: 0,
    class: "count-to-label",
    autoplay: true,
    startVal: 1,
    "end-val": 106.8,
    decimals: 2,
    duration: 3000
  }, null, 8, ["end-val"])) : _createCommentVNode("", true), _hoisted_16]), _hoisted_17]), _createElementVNode("div", _hoisted_18, [_createElementVNode("label", null, [_ctx.activeSliderIndex === 1 ? (_openBlock(), _createBlock(_component_count_to, {
    key: 0,
    class: "count-to-label",
    startVal: 1,
    "end-val": 10000,
    decimals: 2,
    duration: 3000
  })) : _createCommentVNode("", true), _hoisted_19]), _hoisted_20]), _createElementVNode("div", _hoisted_21, [_createElementVNode("label", null, [_ctx.activeSliderIndex === 1 ? (_openBlock(), _createBlock(_component_count_to, {
    key: 0,
    class: "count-to-label",
    startVal: 1,
    "end-val": 2907,
    decimals: 2,
    duration: 3000
  })) : _createCommentVNode("", true), _hoisted_22]), _hoisted_23]), _createElementVNode("div", _hoisted_24, [_createElementVNode("label", null, [_ctx.activeSliderIndex === 1 ? (_openBlock(), _createBlock(_component_count_to, {
    key: 0,
    class: "count-to-label",
    startVal: 1,
    "end-val": 9.85,
    decimals: 1,
    duration: 3000
  }, null, 8, ["end-val"])) : _createCommentVNode("", true), _hoisted_25]), _hoisted_26])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
    src: _ctx.home01
  }, null, 8, _hoisted_28)])], 6)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
    class: _normalizeClass(["project-column default-animation-wrap", {
      entry: _ctx.activeSliderIndex === 2
    }]),
    style: _normalizeStyle({
      height: _ctx.height,
      padding: _ctx.boxPadding
    }),
    id: "project-column"
  }, [_hoisted_30, _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["left-item", [_ctx.currentSchemeIndex === index ? 'active-left-item' : '']]),
      onClick: $event => _ctx.goLink(item),
      key: index,
      onMouseenter: $event => _ctx.cutScheme(item, index)
    }, [_createElementVNode("label", _hoisted_34, "0" + _toDisplayString(index + 1), 1), _createElementVNode("span", _hoisted_35, [_createElementVNode("label", _hoisted_36, _toDisplayString(item.title), 1), _createElementVNode("label", _hoisted_37, _toDisplayString(item.name), 1)])], 42, _hoisted_33);
  }), 128))]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("h3", _hoisted_40, _toDisplayString(_ctx.currentScheme.title), 1), _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.currentScheme.sonTitle), 1)]), _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.currentScheme.describe), 1), _createElementVNode("div", _hoisted_43, [_createElementVNode("img", {
    src: _ctx.currentScheme.img
  }, null, 8, _hoisted_44)])])])], 6)]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", {
    class: _normalizeClass(["about-hd default-animation-wrap", {
      entry: _ctx.activeSliderIndex === 3
    }]),
    style: _normalizeStyle({
      height: _ctx.height,
      padding: _ctx.boxPadding
    }),
    id: "about-hd"
  }, [_hoisted_46, _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_hoisted_49, _hoisted_50, _createElementVNode("div", {
    class: "more me-content",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.goLink({
      path: 'AboutHuoda'
    }, '/us'))
  }, " 了解更多 ")]), _createElementVNode("div", _hoisted_51, [_createElementVNode("img", {
    src: _ctx.aboutLineImg
  }, null, 8, _hoisted_52), _hoisted_53, _createElementVNode("div", _hoisted_54, [_createElementVNode("label", _hoisted_55, [_createElementVNode("img", {
    src: _ctx.aboutPlatformImg
  }, null, 8, _hoisted_56)])]), _hoisted_57])])], 6)]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", {
    class: _normalizeClass(["team-work default-animation-wrap", {
      entry: _ctx.activeSliderIndex === 4
    }]),
    style: _normalizeStyle({
      height: _ctx.height
    }),
    id: "team-work"
  }, [_createElementVNode("div", _hoisted_59, [_hoisted_60, _hoisted_61, _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cooperativeCustomer, (item, index) => {
    return _openBlock(), _createElementBlock("img", {
      key: index,
      src: item
    }, null, 8, _hoisted_64);
  }), 128))])])])], 6)]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", {
    class: "home-footer-content",
    style: _normalizeStyle({
      height: _ctx.height
    })
  }, [_createVNode(_component_Cooperation, {
    title: "业务合作",
    onOpenConsultModdal: _ctx.openConsultModdal
  }, null, 8, ["onOpenConsultModdal"]), _createElementVNode("div", _hoisted_66, [_createVNode(_component_b_footer, {
    from: "home"
  })])], 4)])])])], 4), _createVNode(_component_ConsultModal, {
    ref: "consultModalRef"
  }, null, 512)]);
}